import axios from "networking/axios/axios";
import * as endpoints from "networking/endpoints/endpoints";

export const editSellerApi = (data) =>
    Promise.resolve(axios.post(endpoints.editSeller, data));
